function addHours(date: Date, hours: number) {
    const dateCopy = new Date(date);
    dateCopy.setHours(dateCopy.getHours() + hours);
    return dateCopy;
}

export { addHours }